import { ErrorHandler, Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material';
import { Router, ActivatedRoute } from '@angular/router';
import { throwError } from 'rxjs';
import { LocalAccountService } from './localAccount.service';
import { WebSocketService } from 'app/main/services/webSocket.service';
import { UtilsService } from 'app/main/services/utils.service';

@Injectable({
  providedIn: 'root'
})
export class ErrorHandlerService implements ErrorHandler {

  constructor(
    private localAccountService: LocalAccountService,
    private router: Router,
    private utilsService: UtilsService,
    private webSocketService: WebSocketService,
    private activatedRoute: ActivatedRoute
  ) { }



  handleError(err: any, snackbarDuration?: number) {
    if (this.checkAuthError(err)) {
      this.handleAuthError(err, snackbarDuration);
    } else {
      this.handleServerError(err);
    }
  }

  checkAuthError(err) {
    return (err.status === 401) || (err.status === 403);
  }

  handleAuthError(err, snackbarDuration?: number) {
    if (err.status === 401) {
      const isAdmin = this.localAccountService.isAdmin();
      const isOperator = this.localAccountService.isOperator();
      const isProfessor = this.localAccountService.isProfessor();
      const isStudent = this.localAccountService.isStudent();
      let url;
      if (isAdmin || isOperator) {
        url = '/public-area/user/login/backoffice';
      } else if (isStudent) {
        url = '/public-area/user/login/student';
      } else if (isProfessor) {
        url = '/public-area/user/login/professor';
      } else {
        let fromPage = null;
        if (this.router.url === '/public-area/user/login/backoffice') {
          fromPage = 'backofficeLogin';
        } else if (this.router.url === '/public-area/user/login/student') {
          fromPage = 'studentLogin';
        } else if (this.router.url === '/public-area/user/login/professor') {
          fromPage = 'professorLogin';
        }
        url = '/public-area/redirect'
        if (fromPage) {
          url += `?fromPage=${fromPage}`;
        }
      }
      this.localAccountService.logout();
      this.webSocketService.closeSocket();
      this.router.navigateByUrl(url);
    } else if (err.status === 403) {
      this.router.navigate(['/public-area/error-403']);
    }
    if (err && err.error && err.error.errors) {
      this.newError(err.error.errors.mainMessage || err.error.errors.message, snackbarDuration);
    } else {
      // this.newError(err.message, snackbarDuration);
    }
  }

  handleServerError(err: any, snackbarDuration?: number) {
    let mex = null;
    if (err.error) {
      mex = (err.error.message || err.error.mainMessage);
    }
    if (!mex && err.error.errors) {
      mex = err.error.errors.mainMessage;
    }
    this.newError(mex, snackbarDuration);
    return throwError(new Error(err));
  }

  newError(mex, snackbarDuration?: number) {
    let msg = `Si è verificato un errore durante l'elaborazione della richiesta. Per favore riprova più tardi`;
    if (mex) {
      msg = mex;
    }
    let dur = 3000;
    if (snackbarDuration) {
      dur = snackbarDuration;
    }
    this.utilsService.newWarningSnackbar(msg, snackbarDuration);
    // return this.snackBar.open(msg, '', {
    //   duration: dur,
    //   panelClass: 'warning',
    // });
  }
}
